
import AjaxPlugin from 'vux/src/plugins/ajax/index.js'

import wx from 'weixin-js-sdk'

export default {
name: 'attention',
data() {
return {
imgUrl: '/static/img/qrcode.jpg',
isShow: false
}
},
mounted() {
setTimeout(() => {
var timestamp = parseInt(new Date().getTime() / 1000)
var url
var u = navigator.userAgent
var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
var app = this
app.$http.get('static/config.json').then(response => {
var config = response.data
url = isiOS ? window.location.href : config.host + app.$route.path;
var noncestr = Math.random().toString(36).substr(2)
app.$http.get('/api/v1/wechat/jsApiTicket?timestamp=' + timestamp + '&noncestr=' + noncestr + '&url=' + url)
.then(function (response) {
wx.config({
debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
appId: config.appId, // 必填，公众号的唯一标识
timestamp: timestamp, // 必填，生成签名的时间戳
nonceStr: noncestr, // 必填，生成签名的随机串
signature: response.data, // 必填，签名
jsApiList: ['chooseImage', 'previewImage', 'uploadImage', 'downloadImage', 'translateVoice', 'getLocalImgData', 'checkJsApi', 'scanQRCode'] 
})
wx.error(function (res) {

})
})
.catch(function (error) {

if (error.response) {
console.log(error.response.data)
} else if (error.request) {
console.log(error.request)
} else {
console.log('Error', error.message)
}
})
}, response => {
console.log('数据加载失败')
})
}, 500)
},
beforeRouteEnter(to, from, next) {
let openid = localStorage.getItem('openid');
next(vm => {
AjaxPlugin.$http.get('/api/v1/wechat/' + openid + '/Info')
.then( (response) => {
if (response.data.subscribe) {
vm.$router.push({path: 'sbxx'})
} else {
vm.isShow = true
}
})
.catch(function (error) {
console.log(error)
})
})
}
}



// WEBPACK FOOTER //
// ./src/components/attention.vue